import React from 'react';
import './LeaderboardPage.css';
import { playSound } from '../utils/soundPlayer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
const LeaderboardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="leaderboard-container" style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="https://www.yugiohmeta.com/top-decks"
        title="YuGiOh Meta Top Decks"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
      <button className="back-button" onClick={() => {
        playSound('return');
        navigate('/tool');
      }}>{t('profile.back')}</button>
    </div>
  );
};

export default LeaderboardPage;
